import {componentsHelper} from './_helper'

export default [
  {
    path: '/checkout',
    ...componentsHelper('checkout/index')
  },
  {
    path: '/checkout/shipping',
    ...componentsHelper('checkout/shipping')
  },
  {
    path: '/checkout/checkout',
    ...componentsHelper('checkout/checkout')
  },
  {
    path: '/checkout/completed',
    ...componentsHelper('checkout/completed')
  },
  {
    path: '/checkout/twint',
    name: 'checkout/twintPayment',
    components: {
      desktop: () => import('../views/common/checkout/twintPayment'),
      mobile: () => import('../views/common/checkout/twintPayment')
    }
  },
  {
    path: '/checkout/stripe',
    name: 'checkout/stripePayment',
    components: {
      desktop: () => import('../views/common/checkout/stripePayment'),
      mobile: () => import('../views/common/checkout/stripePayment')
    }
  }
]



// WEBPACK FOOTER //
// ./client/router/checkout.js